import BannerPC from '@rebuild/materials/shared/banner/BannerPC.vue';

export const componentMap = {
	basic: BannerPC
};
